import styled, { css } from 'styled-components';

export const ListItem = styled.li`
	text-indent: 0;
	list-style-type: none;
	position: relative;
	display: flex;
	flex: 1;
	margin: 0;
	padding: 30px 0 0 0;
	border-top: 2px solid #e6e6e6;

	& > div {
		flex: 1;
		box-sizing: border-box;
		width: 100%;
		margin: 0;
	}

	&::before {
		top: 0;
		left: 50%;
		position: absolute;
		height: 34px;
		border-left: 2px solid #e6e6e6;
		content: '';
	}

	&:last-child,
	&:first-child {
		border-top: 2px solid transparent;
	}

	&:first-child::before {
		left: 50%;
		right: 0;
		top: -2px;
		position: absolute;
		border: 0;
		border-top: 2px solid #e6e6e6;
		border-left: 2px solid #e6e6e6;
		border-radius: 0 0 0 3px;
	}

	&:last-child::before {
		right: 50%;
		left: 0;
		top: -2px;
		position: absolute;
		border: 0;
		border-top: 2px solid #e6e6e6;
		border-right: 2px solid #e6e6e6;
		border-radius: 0 0 0 3px;
	}
`;

const singleItemListLayout3Styles = css`
	${ListItem} {
		margin: 0 auto;
	}
	${ListItem}::before {
		display: none;
	}
`;

const singleItemListLayout2Styles = css`
	${ListItem} {
		max-width: calc(50% - 56px);
		margin: 0 auto;

		& > div {
			margin: 0;
			padding: 0;
			flex: 1;
		}
	}
	${ListItem}::before {
		display: none;
	}
`;

const pairItemListLayout3Styles = css`
	${ListItem}:first-child {
		margin: 0 0 0 auto;
	}
	${ListItem}:last-child {
		margin: 0 auto 0 0;
	}
`;

const connectorLineLayout3Styles = css`
	${ListItem} {
		& > div {
			margin: 0;
			padding: 0;
			flex: 1;
		}
	}
	${ListItem}::before {
		display: block;
		right: calc(50% - 1px);
		border-top: none;
	}
`;

const connectorLineLayout2Styles = css`
	${ListItem} {
		& > div {
			margin: 0;
			padding: 0;
			flex: 1;
		}
	}
	${ListItem}::before {
		display: block;
		right: calc(50% - 2px);
		border-top: none;
	}
`;

export const List = styled.ul`
	margin: 0;
	padding: 0;
	text-indent: 0;
	list-style-type: none;
	display: flex;
	padding-top: 32px;

	${({ colsPerRow, pairItemList }) =>
		pairItemList ? (colsPerRow === 3 ? pairItemListLayout3Styles : '') : ''};

	${({ colsPerRow, singleItemList }) =>
		singleItemList
			? colsPerRow === 2
				? singleItemListLayout2Styles
				: singleItemListLayout3Styles
			: ''};

	${({ keepConnectorLine, singleItemList, colsPerRow }) =>
		singleItemList && keepConnectorLine
			? colsPerRow === 2
				? connectorLineLayout2Styles
				: connectorLineLayout3Styles
			: ''};

	${({ colsPerRow }) =>
		colsPerRow === 2
			? css`
					${ListItem} {
						width: 50%;
						max-width: 50%;
						min-width: 50%;
					}
					${ListItem}:last-child > div {
						padding: 0 0 0 28px;
					}
					${ListItem}:first-child > div {
						padding: 0 28px 0 0;
					}
					${ListItem}:first-child:last-child > div {
						padding: 0 14px;
					}
			  `
			: css`
					${ListItem} {
						width: 33.33%;
						max-width: 33.33%;
						min-width: 33.33%;
					}
					${ListItem} > div {
						padding: 0 19px;
					}
					${ListItem}:last-child > div {
						padding: 0 0 0 38px;
					}
					${ListItem}:first-child > div {
						padding: 0 38px 0 0;
					}
					${ListItem}:first-child:last-child > div {
						padding: 0 19px;
					}
			  `};
`;

export const TopItem = styled.div`
	width: 33.333%;
	margin: 0 auto;
	position: relative;

	&::after {
		bottom: -32px;
		left: 50%;
		position: absolute;
		height: 32px;
		border-left: 2px solid #e6e6e6;
		content: '';
	}

	& > div {
		padding: 0 19px;
	}

	${({ colsPerRow }) =>
		colsPerRow === 2
			? css`
					width: 50%;
					& > div {
						padding: 0 14px;
					}
			  `
			: ''};
`;
